import * as React from 'react';

function IconGlobalSettingsSmall(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M14 9V7H11.86C11.761 6.64931 11.6164 6.31311 11.43 6L13 4.46L11.54 3.05L10 4.57C9.68689 4.38359 9.35069 4.23902 9 4.14V2H7V4.14C6.64931 4.23902 6.31311 4.38359 6 4.57L4.46 3.05L3.05 4.46L4.57 6C4.38359 6.31311 4.23902 6.64931 4.14 7H2V9H4.14C4.23902 9.35069 4.38359 9.68689 4.57 10L3.05 11.54L4.46 13L6 11.43C6.31311 11.6164 6.64931 11.761 7 11.86V14H9V11.86C9.35069 11.761 9.68689 11.6164 10 11.43L11.54 13L13 11.54L11.43 10C11.6164 9.68689 11.761 9.35069 11.86 9H14ZM8 10C7.60444 10 7.21776 9.8827 6.88886 9.66294C6.55996 9.44318 6.30362 9.13082 6.15224 8.76537C6.00087 8.39991 5.96126 7.99778 6.03843 7.60982C6.1156 7.22186 6.30608 6.86549 6.58579 6.58579C6.86549 6.30608 7.22186 6.1156 7.60982 6.03843C7.99778 5.96126 8.39991 6.00087 8.76537 6.15224C9.13082 6.30362 9.44318 6.55996 9.66294 6.88886C9.8827 7.21776 10 7.60444 10 8C10 8.53043 9.78929 9.03914 9.41421 9.41421C9.03914 9.78929 8.53043 10 8 10Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconGlobalSettingsSmall;
